import { Component } from '@angular/core';
import { CardComponent } from '@components/card/card.component';

@Component({
  selector: 'app-order-complete-instructions-female-condom',
  templateUrl: './order-complete-instructions-female-condom.component.html',
  imports: [CardComponent],
})
export class OrderCompleteInstructionsFemaleCondomComponent {}
